<script>
import EcSpinner from '../ui/EcSpinner.vue'

export default {
  name: 'PackageEditor',
  components: {
    EcSpinner,
  },
  props: {
    editorUrl: {
      type: String,
      required: true,
    },
    height: {
      type: String,
      default: '600px',
    },
  },
  data() {
    return {
      iframeLoading: true,
    }
  },
  computed: {
    isFlexMode() {
      return this.height === '100%'
    },
    containerStyle() {
      return this.isFlexMode ? {} : { height: this.height }
    },
  },
  methods: {
    onIframeLoad() {
      this.iframeLoading = false
    },
  },
}
</script>

<template>
  <div
    class="ec-package-editor"
    :class="{ 'ec-package-editor--flex': isFlexMode }"
    :style="containerStyle"
  >
    <div
      v-if="iframeLoading"
      class="ec-flex ec-justify-center ec-items-center"
      style="position: absolute; inset: 0"
    >
      <EcSpinner />
    </div>
    <iframe
      v-show="!iframeLoading"
      :src="editorUrl"
      class="ec-package-editor__iframe"
      frameborder="0"
      allowfullscreen
      @load="onIframeLoad"
    />
  </div>
</template>

<style scoped>
.ec-package-editor {
  position: relative;
  min-height: 200px;
}

.ec-package-editor--flex {
  flex: 1;
  display: flex;
  flex-direction: column;
}

.ec-package-editor__iframe {
  width: 100%;
  height: 100%;
  border: none;
}

.ec-package-editor--flex .ec-package-editor__iframe {
  flex: 1;
}
</style>
